import { observer } from 'mobx-react-lite';
import { ConfirmPopup } from '../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../hooks/useStore';
import styles from './DeleteAppointmentDialog.module.css';

const formatDate = (value?: string) => {
  if (!value) {
    return '—';
  }

  return new Date(value).toLocaleDateString('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

type DeleteAppointmentDialogProps = {
  onDeleted?: () => void;
};

const DeleteAppointmentDialog = ({ onDeleted }: DeleteAppointmentDialogProps) => {
  const { popupStore, appointmentStore } = useStore();
  const appointment = appointmentStore.appointmentToDelete;

  const handleClose = () => {
    popupStore.setIsDeleteAppointmentConfirmationOpen(false);
    appointmentStore.setAppointmentToDelete(null);
  };

  const handleConfirm = async () => {
    if (!appointment?.id) {
      return;
    }

    await appointmentStore.deleteAppointment(appointment.id);
    onDeleted?.();
    handleClose();
  };

  const message = appointment ? (
    <div className={styles.content}>
      <p className={styles.message}>Aşağıdaki randevuyu silmek istediğinizden emin misiniz?</p>
      <ul className={styles.detailList}>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Kişi</span>
          <span className={styles.detailValue}>{appointment.personName || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Hastane</span>
          <span className={styles.detailValue}>{appointment.hospitalName || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Etiket No</span>
          <span className={styles.detailValue}>{appointment.requestNumber || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Randevu Tarihi</span>
          <span className={styles.detailValue}>{formatDate(appointment.appointmentDate)}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Saat</span>
          <span className={styles.detailValue}>
            {appointment.appointmentStartTime && appointment.appointmentEndTime
              ? `${appointment.appointmentStartTime} - ${appointment.appointmentEndTime}`
              : appointment.appointmentStartTime || '—'}
          </span>
        </li>
      </ul>
      <p className={styles.warning}>Bu işlem geri alınamaz.</p>
    </div>
  ) : (
    'Bu randevuyu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'
  );

  const result = (
    <ConfirmPopup
      isOpen={popupStore.isDeleteAppointmentConfirmationOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      intent="delete"
      title="Randevu Silme Onayı"
      description="Silme işlemi kalıcıdır"
      message={message}
      closeOnConfirm={false}
    />
  );

  return result;
};

export default observer(DeleteAppointmentDialog);
